import React from "react";
import classNames from "classnames/bind";

import { Button } from "../Button";
import { ProgressBar } from "../ProgressBar";

import { useStateManager } from "utils/useStateManager";

import { ReactComponent as ArrowLeft } from "../../icons/arrow_small_l.svg";

import styles from "./Screen.module.css";

const cx = classNames.bind(styles);

type Props = {
  title: React.ReactNode;
  onBack?: () => void;
  onForward?: () => void;
  isInvalid?: boolean;
  isLoading?: boolean;
  onSubmit?: (event: React.FormEvent<HTMLFormElement>) => void;
  buttonTitle?: React.ReactNode | boolean;
  shortProduct?: boolean;
};

export const Screen: React.FC<Props> = (props) => {
  const { progress } = useStateManager();

  const content = (
    <div className={cx("inner")}>
      <header className={cx("header")}>
        {props.onBack && (
          <button
            className={cx("back")}
            onClick={props.onBack}
            type="button"
            aria-label="Назад"
          >
            <ArrowLeft width={16} height={16} />
          </button>
        )}
        <h1 className={cx("title")}>{props.title}</h1>
        {props.onForward && (
          <button
            className={cx("forward")}
            onClick={props.onForward}
            type="button"
            aria-label="Назад"
          >
            <ArrowLeft width={16} height={16} />
          </button>
        )}
        <ProgressBar progress={progress} />
      </header>
      <div className={cx('content')} style={{ justifyContent: !props.shortProduct ? "" : "center" }}>
        {!props.shortProduct ? (
          props.children
        ) : (
          <Button
            color="cerulean"
            block
            size="medium"
            rounded
            disabled={props.isInvalid}
            isLoading={props.isLoading}
            type="submit"
          >
            Скачать отчет
          </Button>
        )}
      </div>
      {props.buttonTitle && (
        <div className={cx("footer")}>
          <div className={cx("button")} onClick={() => window.scrollTo(0, 0)}>
            <Button
              color="cerulean"
              block
              size="medium"
              rounded
              disabled={props.isInvalid}
              isLoading={props.isLoading}
              type="submit"
            >
              {props.buttonTitle}
            </Button>
          </div>
        </div>
      )}
    </div>
  );

  if (props.onSubmit) {
    return (
      <form className={cx("screen")} id={"screen"} onSubmit={props.onSubmit}>
        {content}
      </form>
    );
  }

  return (
    <div className={cx("screen")} id={"screen"}>
      {content}
    </div>
  );
};
